import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, Button, Table, Spinner } from "reactstrap";
import dayjs from "dayjs";

const formatUserAccessDate = (value = "") => {
    if (!value) return "—";
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("h:mm A MM-DD-YYYY") : String(value);
};

const mapModalUserRow = (user = {}) => {
    const startDateDisplay = String(user?.startDateDisplay ?? "").trim();
    const startDate = user?.startDate ?? user?.date ?? user?.dateTime ?? "";

    return {
        userName:
            user?.userName ??
            user?.user ??
            user?.name ??
            user?.displayName ??
            "—",
        dateLabel: startDateDisplay || formatUserAccessDate(startDate),
    };
};

const ReportClientUserModal = ({
    isOpen = false,
    onClose,
    users = [],
    loading = false,
}) => {
    const rows = Array.isArray(users) ? users : [];

    return (
        <Modal isOpen={isOpen} toggle={onClose} backdrop="static" className="modal-full-height" centered>
            <ModalBody className="p-4 modal-height-fixed">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">CLIENT USER</h5>
                    <Button close onClick={onClose} />
                </div>

                {loading ? (
                    <div className="text-center py-4">
                        <Spinner size="sm" className="me-2" />
                        Loading…
                    </div>
                ) : (
                    <Table bordered responsive>
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length ? (
                                rows.map((user, index) => {
                                    const mapped = mapModalUserRow(user);
                                    return (
                                        <tr key={user?.id || user?.userId || index}>
                                            <td>{mapped.userName}</td>
                                            <td>{mapped.dateLabel}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={2} className="text-center text-muted">
                                        No user access records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </ModalBody>
        </Modal>
    );
};

ReportClientUserModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    users: PropTypes.array,
    loading: PropTypes.bool,
};

export default ReportClientUserModal;
